import { useState, useEffect } from 'react'

export type DeviceType = 'mobile' | 'tablet' | 'desktop'

interface ResponsiveConfig {
  deviceType: DeviceType
  isMobile: boolean
  isTablet: boolean
  isDesktop: boolean
  maxWidth: string
}

export function useResponsive(): ResponsiveConfig {
  const [deviceType, setDeviceType] = useState<DeviceType>('mobile')

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth

      if (width < 768) {
        setDeviceType('mobile')
      } else if (width < 1024) {
        setDeviceType('tablet')
      } else {
        setDeviceType('desktop')
      }
    }

    // Llamar una vez al montar
    handleResize()

    // Agregar listener
    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const config: ResponsiveConfig = {
    deviceType,
    isMobile: deviceType === 'mobile',
    isTablet: deviceType === 'tablet',
    isDesktop: deviceType === 'desktop',
    maxWidth:
      deviceType === 'mobile' ? '600px' : deviceType === 'tablet' ? '900px' : '1200px',
  }

  return config
}
